module.exports = __webpack_public_path__ + "img/375.47ff3954.jpg";